import { render } from "./HomePalettesGrid.vue?vue&type=template&id=2fe12b0a&scoped=true&ts=true"
import script from "./HomePalettesGrid.vue?vue&type=script&lang=ts"
export * from "./HomePalettesGrid.vue?vue&type=script&lang=ts"

import "./HomePalettesGrid.vue?vue&type=style&index=0&id=2fe12b0a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe12b0a"]])

export default __exports__